import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { AppState } from './store'

interface PersonalFilterState {
  data: any
  deselectedColumns: string[]
}

const initialState: PersonalFilterState = {
  data: undefined,
  deselectedColumns: ['Period'],
}

const personalFilterSlice = createSlice({
  name: 'personalFilter',
  initialState,
  reducers: {
    setPersonalFilter(state, action: PayloadAction<{ data: any }>) {
      state.data = action.payload.data
    },
    setPersonalDeselectedColumns(state, action: PayloadAction<string[]>) {
      state.deselectedColumns = action.payload
    },
  },
})

export const getPersonalFilter = (state: AppState) => state.personalFilterReducer.data
export const getPersonalDeselectedColumns = (state: AppState) => state.personalFilterReducer.deselectedColumns
export const { setPersonalFilter, setPersonalDeselectedColumns } = personalFilterSlice.actions
export default personalFilterSlice.reducer
